#import "../fragments/saved-list-stub-fragment.graphql"

query GetDefaultFilters($type: SavedFiltersReportType!, $searchNameQuery: String) {
    defaultFilters(type: $type, searchNameQuery: $searchNameQuery) {
        ...SavedListStubFragment
    }
}
